export const checkForOverride = (
	baseTheme,
	graphic,
	theme,
	section,
	element
) => {
	let css = baseTheme?.[section]?.[element];
	if (css === undefined) return "";

	return css;
};

export const linearGradient = (baseTheme, graphic, theme, section) => {
	let c1 = checkForOverride(baseTheme, graphic, theme, section, "colour");
	let grad = checkForOverride(baseTheme, graphic, theme, section, "gradient");
	let c2 =
		checkForOverride(baseTheme, graphic, theme, section, "colour2") || c1;
	let lg = `linear-gradient(${
		[false, "false", ""].includes(grad) ? -1 : grad
	}deg, ${c1} 0%, ${[false, "false"].includes(grad) ? c1 : c2} 100%)`;

	return lg;
};

export const glow = (baseTheme, graphic, theme) => {
	let gl = `0vw 0vw ${
		checkForOverride(baseTheme, graphic, theme, "background", "glowBlur") || 0
	}vw ${checkForOverride(baseTheme, graphic, theme, "background", "colour")}`;

	return gl;
};
